import script from "./recharge.vue?vue&type=script&setup=true&lang=js"
export * from "./recharge.vue?vue&type=script&setup=true&lang=js"

import "./recharge.vue?vue&type=style&index=0&id=4b62c486&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b62c486"]])

export default __exports__